<template>

<div class="row">

	<slot></slot>

</div>

</template>

<script>

export default {


}

</script>

<style scoped>

.row {
	display: flex;
	flex-direction: row;
}

.is-mobile .row {
    flex-wrap: wrap;
}

</style>